import { useContext, useMemo } from 'react';
import type { ReactNode } from 'react';

import { windowIsAvailable } from '../../utils';

import { ConfigurationContext } from './Configuration';

export interface LocaleOverrideProps {
  /** Content that will inherit locale overrides. */
  children: ReactNode;
  /** Calendar type to override locale properties. */
  calendar?: Intl.LocaleOptions['calendar'];
}

const LocaleOverride = ({ children, calendar }: LocaleOverrideProps) => {
  const context = windowIsAvailable
    ? window.cosmos.configurationContext ?? ConfigurationContext
    : ConfigurationContext;

  const ctx = useContext(context);
  const override = useMemo(() => {
    if (!calendar) {
      return ctx.locale;
    }
    return new Intl.Locale(ctx.locale, { calendar }).toString();
  }, [ctx.locale, calendar]);

  return (
    <context.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{ ...ctx, locale: override }}
    >
      {children}
    </context.Provider>
  );
};

export default LocaleOverride;
